<template lang="pug">
  .header__video(v-if="poster || mp4")
    video(
      :poster="poster"
      muted
      autoplay
      loop
      playsinline
    )
      source(
        :src="mp4"
        type="video/mp4"
      )
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'HeaderVideo',
  data: () => ({
    poster: null,
    mp4: null,
    countryCode: '',
    specialCountries: ['by', 'kz', 'ar']
  }),
  computed: {
    ...mapState('siteVersions', {
      currentCountry: state => state.item
    })
  },
  watch: {
    currentCountry () {
      if (this.specialCountries.includes(this.currentCountry?.code)) {
        this.countryCode = this.currentCountry?.code
      } else {
        this.countryCode = 'global'
      }

      this.poster = window.innerWidth > 1024
        ? require(`@/assets/video/header-${this.countryCode}.jpg`)
        : require(`@/assets/video/mobile-header-${this.countryCode}.jpg`)

      this.mp4 = window.innerWidth > 1024
        ? require(`@/assets/video/header-${this.countryCode}.mp4`)
        : require(`@/assets/video/mobile-header-${this.countryCode}.mp4`)
    }
  }
}
</script>
